import React from 'react'

// Tranlations
import t from '../../translations'

export default function Privacy(props) {
    return <section className={props.loginModalOpen ? 'blured' : ''}>
        <h1>{t[props.lang].specifics_footerPrivacy['page title']}</h1>

        <div className='subPageInner'>
            <h2>{t[props.lang]['subtitle 1']}</h2>
            {t[props.lang]['bulletList 1']}
            <h2>{t[props.lang]['subtitle 2']}</h2>
            <p>{t[props.lang]['text 1']}</p>
        </div>
    </section >
}